/** 与 roleadmin.vue / adminlevel 一致的管理员层级 */
const USER_TYPE_ROLE_MAP: Record<number, string> = {
  0: "系统管理员",
  1: "总管理",
  2: "高级管理",
  3: "一级管理",
  4: "二级管理"
};

export function resolveSystemPermission(loginUser?: {
  role?: { name?: string | null } | null;
  userType?: number | null;
} | null): string {
  const roleName = loginUser?.role?.name?.trim();
  if (roleName) {
    return roleName;
  }
  const userType = Number(loginUser?.userType);
  if (Number.isFinite(userType) && USER_TYPE_ROLE_MAP[userType]) {
    return USER_TYPE_ROLE_MAP[userType];
  }
  return "";
}
